export const iconFontAwesomeSecurityShieldCat = (
	<i className="fa-solid fa-shield-cat"></i>
);
